export default (props, vars) =>
  vars?.['uselookbook2']?.['lookbook']?.about?.job_name;
